<template>
  <a-table
    :columns="columns"
    :data-source="list"
    :row-key="(record) => record.id"
    :scroll="{ x: 0, y: 500 }"
    :pagination="false"
  ></a-table>
</template>
<script>
import { rawMaterialColumns } from "../../../EstimateConfig/formulaConfig";
export default {
  props: ["details"],
  data() {
    return {
      list: [],
      columns: rawMaterialColumns,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        formulaId: this.details.formulaId,
        factoryId: this.details.factoryId,
        current: 1,
        size: 1000,
      };
      this.$http
        .get("/nhf-app/formulaNhf/formulaRawNhfPage", { params })
        .then((res) => {
          let { success, data } = res;
          if (success) {
            let { records } = data;
            this.list = records || [];
          } else {
            this.list = [];
          }
        })
        .catch(() => {
          this.list = [];
        });
    },
  },
};
</script>